import React, {Component} from 'react';
import CBaseComponent from '@/components/CBaseComponent'
import CButton from '@/components/CButton'
import {connect} from 'react-redux'
import { setStorage,getStorage} from "@/utils";
import CTable from '@/components/CTable'
import CInput from '@/components/CForm/CInput'
import './index.scss'
import {Card, Modal, Button, Empty, message} from "antd";
import {bindActionCreators, compose} from "redux";
import { withRouter} from 'react-router-dom'
import { submitdata,selectIndex,museumvote } from "@/servers/commonApi";
import {museumlist} from "../../servers/goodsManageApi";

import {
    setLibrary, setLbname, setLibraryArr,
} from "../../redux/common/action";
import {selectLibraryHeader} from "../../servers/goodsManageApi";
@CBaseComponent
class Home extends Component{
    constructor(props) {
        super(props);
        this.detail=this.detail.bind(this)
        this.selectdata = this.selectdata.bind(this)
        this.getAlert = this.getAlert.bind(this)
        this.searchHandler = this.searchHandler.bind(this)
        this.handleCanceldialog = this.handleCanceldialog.bind(this)
        this.selectdataForm = this.selectdataForm.bind(this)
        this.onTableChange = this.onTableChange.bind(this)
    }


    state = {
        fileslist:[],
        newslist:[],
        step:'',
        result:{},
        dataSource: [],
        page: {
            total: 0,
            page: 1,
            pageSize: 10
        },
        loading: true,
        museumname:'',
        columns: [
            {
                key: 'name',
                dataIndex: 'name',
                title: '序号',
                align:'center',
                slot:'index'
            },
            {
                key: 'museumname',
                dataIndex: 'museumname',
                title: '博物馆名称',
                align:'center'
            },
            {
                key: 'province',
                dataIndex: 'province',
                title: '省份',
                align:'center'
            },
            {
                title: '内容查看',
                align:'center',
                slot:'select'
            },
            {
                title: '投票状态',
                align:'center',
                slot:'piao'
            },
            {
                title: '操作',
                align:'center',
                slot:'operate'
            },
        ],
        columns1: [
            {
                key: 'name',
                dataIndex: 'name',
                title: '序号',
                align:'center',
                slot:'index'
            },
            {
                key: 'museumname',
                dataIndex: 'museumname',
                title: '博物馆名称',
                align:'center'
            },
            {
                key: 'filecount',
                dataIndex: 'filecount',
                title: '操作',
                align:'center',
                slot:'operate'
            },
        ],
        votedlist:[],
        dataSourceall:[]
    };

    onTableChange(data){
        let d =this.state.dataSourceall
        var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
        var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
        var newDataList = [];
        for(var i = bIndex;i < eIndex;i++){
            if (d[i]) {
                newDataList.push(d[i]);
            }
        }
        this.setState({
            page: {...this.state.page, ...data.data},
            dataSource:newDataList
        })
    }


    showModal = (data) => {
        this.setState({
            isModalVisible:true
        })
        var newStr = decodeURI(data.content).replaceAll("++++","\n");
        this.setState({
            title:data.title,
            name: data.postedby,
            time:data.postedtime,
            content:newStr
        })
    };

    handleCanceldialog(){
        this.setState({
            title: '',
            content:'',
            isModalVisible: false
        })
    }


    searchHandler(value){
        this.setState({
            museumname:value
        })
    }

    selectdataForm(){
        this.setState({
            loading: true
        });
        museumlist({museumname:this.state.museumname}).then(res => {
            if (res.statecode === 0) {
                this.setState({
                    loading: false,
                    dataSource:res.records[0].datalist
                });
            }
        }).catch(err => {
            console.log(err, 'rttt')
        })
    }

    handleCancel = () => {
        this.setState({
            isModalVisible:false
        })
    };


    componentWillReceiveProps(nextProps){

    }


    getAlert(data){
        const params = {
            mimid: data.id,
            vote:data.vote == '0' ? 1 : 0
        }
        museumvote(params).then(res=>{
            if (res.statecode === 0) {
                const str = data.vote == '0'?'投票成功':'取消投票成功'
                message.success(str);
                this.selectdata()
            } else {
                message.error(res.statemessage);
            }
        })
    }

    detail(data){
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        const params = {
            provinceid:data.provinceid,
            miid:userInfo[0].miid
        }
        selectLibraryHeader(params).then(res=>{
            if (res.records.length > 0) {
                const result = res.records[0].datalist
                result.forEach(item=>{
                    item.name = item.museumname
                })
                this.props.setLibraryArr(result)
                this.props.setLibrary(data.id)
                this.props.setLbname(data.museumname)
                localStorage.setItem('chooseid','21')
                this.props.history.push({
                    pathname: '/base'
                })
            }
        })
    }

    selectdata(){
        this.setState({
            loading:true
        })
        selectIndex({museumname:this.state.museumname}).then(res=>{
            if (res.statecode === 0) {
                let d = JSON.parse(JSON.stringify(res.records[0].datalist))
                let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)
                this.setState({
                    votedlist:[]
                })
                this.setState({
                    dataSource:data,
                    dataSourceall:res.records[0].datalist,
                    page:{...this.state.page,total:res.records[0].datalist.length},
                    fileslist:res.records[0].filelist,
                    newslist:res.records[0].bulletinlist,
                    votedlist:res.records[0].votedlist,
                    loading:false,
                })
            } else {
                message.error(res.statemessage);
            }
        })
    }

    selectlibrary(){

    }


    componentWillMount(){
    }

    componentDidMount(){
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.setState({
            step:userInfo[0].step
        })
        this.selectdata()
    }

    render(){
        return (
            <main style={{textAlign:'left'}} className='containerblock'>
                <div className='contents'>
                    <div className='zhibiao'>
                        <span>当前进展：{this.state.step}</span>
                    </div>
                   <div className='tablesindex'>
                       <div className='filter-wrap'>
                           <div className='flex filter-left'>
                               <h3>投票博物馆列表</h3>
                               <span>【最多可投票2家博物馆】</span>
                           </div>
                           <div className='flex filter-right'>
                               <CInput value={this.state.museumname}
                                       className='search-input'
                                       placeholder='请输入博物馆名称'
                                       onChange={this.searchHandler} />
                               <CButton type='primary' onClick={this.selectdataForm}>搜索</CButton>
                           </div>
                       </div>
                       <CTable ref='historyRecordDeleteUserList' checked={false} loading={false}
                               columns={this.state.columns} dataSource={this.state.dataSource}
                               page={this.state.page}
                               onTableChange={this.onTableChange}>
                           <div
                               slot='index'
                               render={(text, record, index) => (
                                   <div className='operate'>
                                       {index + 1}
                                   </div>
                               )}/>
                           <div
                               slot='select'
                               render={(text, record, index) => (
                                   <div className='operate'>
                                       <CButton type='text' size="mini" onClick={() => this.detail(record)} style={{fontSize:'12px'}}>
                                           查看
                                       </CButton>
                                   </div>
                               )}/>
                           <div
                               slot='piao'
                               render={(text, record, index) => (
                                   <div className='operate'>
                                       {record.vote == '0' ? '未投票' : '已投票'}
                                   </div>
                               )}/>
                           <div
                               slot='operate'
                               render={(text, record, index) => (
                                   <div className='operate'>
                                       {
                                           record.vote == '0'?
                                               <CButton type='text' size="mini" onClick={() => this.getAlert(record)} style={{fontSize:'12px',color:'blue'}}>
                                                   投票
                                               </CButton> :
                                               <CButton type='text' size="mini" onClick={() => this.getAlert(record)} style={{fontSize:'12px'}}>
                                                   取消投票
                                               </CButton>
                                       }
                                   </div>
                               )}/>
                       </CTable>
                   </div>
                    <div className='tablesindex' style={{marginTop: '20px'}}>
                        <div className='filter-wrap'>
                            <div className='flex filter-left'>
                                <h3>已投票博物馆列表</h3>
                            </div>
                        </div>
                        <CTable ref='historyRecordDeleteUserList' checked={false} loading={false}
                                columns={this.state.columns1} dataSource={this.state.votedlist}>
                            <div
                                slot='index'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        {index+1}
                                    </div>
                                )} />
                            <div
                                slot='operate'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        {
                                            record.museumname?
                                                <CButton type='text' size="mini" onClick={() => this.detail(record)} style={{fontSize:'12px'}}>
                                                    查看
                                                </CButton>:''
                                        }
                                    </div>
                                )} />
                        </CTable>
                    </div>
                    <div className='system-info'>
                        <div className='system-tz'>
                            <Card title="系统公告" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.newslist.length === 0? <Empty></Empty>:
                                        this.state.newslist.map(item=>{
                                            return <div onClick={()=>{this.showModal(item)}} className='new-block'>
                                                {
                                                    Number(item.top > 1000) ?
                                                        <span className='important'>{item.title}</span>:
                                                        <span>{item.title}</span>
                                                }
                                                <span>{item.postedtime}</span>
                                            </div>
                                        })
                                }
                            </Card>
                        </div>
                        <div className='system-file'>
                            <Card title="文件中心" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.fileslist.length === 0? <Empty></Empty>:
                                        this.state.fileslist.map(item=>{
                                            return <div onClick={()=>{this.downloads(item)}} className='new-block'>
                                                <a href={item.fileurl} style={{color:'rgb(60, 185, 241)'}}>{item.title}</a >
                                            </div>
                                        })
                                }
                            </Card>
                        </div>
                    </div>
                    </div>
                <Modal title={this.state.title}
                       visible={this.state.isModalVisible}
                       onCancel={this.handleCanceldialog}
                       centered={true}
                       footer={[
                           <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                               取消
                           </Button>
                       ]}
                >
                    <div style={{marginTop:'-10px',textAlign:'center',marginBottom:'10px'}}><span style={{marginRight:'10px'}}>{this.state.name}</span><span>{this.state.time}</span></div>
                    <div style={{whiteSpace: 'pre-wrap'}}>{this.state.content}</div>
                </Modal>
            </main>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userList:  state.userList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setLibrary: bindActionCreators(setLibrary, dispatch),
        setLbname: bindActionCreators(setLbname, dispatch),
        setLibraryArr: bindActionCreators(setLibraryArr, dispatch),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Home);
